import { Modal } from "./Modal.jsx";
import { Button } from "./Button.jsx";

/**
 * Confirmation modal — used before any destructive admin action (delete,
 * disable, force-reset). Tone="danger" colors the confirm button red.
 */
export function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title = "Are you sure?",
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  tone = "danger",
  loading = false,
}) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      description={description}
      size="sm"
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button
            variant={tone === "danger" ? "danger" : "primary"}
            onClick={onConfirm}
            loading={loading}
          >
            {confirmLabel}
          </Button>
        </>
      }
    >
      {/* Body intentionally empty — title + description carry the message.
          Caller can pass children to add custom content if needed. */}
      <span className="sr-only">Confirmation</span>
    </Modal>
  );
}
